

import { Component, Input, OnInit, OnChanges, ViewChild, SimpleChanges } from '@angular/core';
import * as _ from 'underscore';
import {isNil, cloneDeep } from 'lodash-es';
import { ChartOptions } from 'chart.js';

const AIA_BLUE = '#22a8da';
const GRAPHITE_GREY = '#616161';

@Component({
    selector: 'app-derivative-holdings-chart',
    templateUrl: './derivative-holdings-chart.component.html',
    styleUrls: ['./derivative-holdings-chart.component.scss'],
    standalone: false
})
export class DerivativeHoldingsChartComponent implements OnInit, OnChanges {

    @Input()
    aampUsedQuotaList: any[];

    @Input()
    aampUsedSimuQuotaList: any[];

    public barChartOptionsNovo: ChartOptions<'bar'> = {
        // We use these empty structures as placeholders for dynamic theming.
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        scales: {
            x: {
                position: "top",
                stacked: true,
                grid: {
                    display: true
                }, 
                ticks:{
                    font: {
                        size: 11
                    }
                }
            },
            y: {
                stacked: true,
                grid: {
                    display: true
                },
                ticks: {
                    padding: 10,
                }
            },
        },
        plugins: {
            title: {
                display: true,
                text: 'M USD'
            },
            legend: {
                display: true,
            }
        },
    };

    public barChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            intersect: true,
            mode: 'point',
            callbacks: {
                mode: 'y'
            }
        },
        scales: {
            xAxes: [{
                stacked: true,
                position: 'top',
                ticks: {
                    min: 0,
                    fontSize: 11
                },
                gridLines: {
                    display: true,
                    drawTicks: false
                },
                scaleLabel: {
                    display: true,
                    labelString: 'M USD'
                }
            }/*, {
                position: 'bottom',
                ticks: {
                    display: false
                },
                gridLines: {
                    display: false,
                    drawTicks: false
                },
                scaleLabel: {
                    display: false
                }
            } */],
            yAxes: [{
                stacked: true,
                gridLines: {
                    display: true,
                    drawTicks: false
                },
                ticks: {
                    padding: 10
                }
            }]
        }
    };
    public barChartLabels: string[] = [];
    public barChartType = 'bar';
    public barChartLegend = false;

    public barChartData: any[] = [ { data: [] }, { data: [] } ];

    colorArray = [{
        backgroundColor: GRAPHITE_GREY,
        hoverBackgroundColor: GRAPHITE_GREY,
        borderColor: GRAPHITE_GREY,
        hoverBorderColor: GRAPHITE_GREY
    }, {
        backgroundColor: AIA_BLUE,
        hoverBackgroundColor: AIA_BLUE,
        borderColor: AIA_BLUE,
        hoverBorderColor: AIA_BLUE
    }];

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if ((!changes.aampUsedQuotaList) && (!changes.aampUsedSimuQuotaList)) {
            return;
        }
        this.resetChartData();
        this.populateChartData(changes.aampUsedQuotaList     ? changes.aampUsedQuotaList.currentValue     : this.aampUsedQuotaList,
                               changes.aampUsedSimuQuotaList ? changes.aampUsedSimuQuotaList.currentValue : this.aampUsedSimuQuotaList);
    }

    populateChartData(aampUsedQuotaList: any[], aampUsedSimuQuotaList: any[]) {
        const chartData = cloneDeep(aampUsedQuotaList);
        const chartSimuData = cloneDeep(aampUsedSimuQuotaList);
        if (isNil(chartSimuData) || chartSimuData.length === 0) {
            const mydata = [];
            const mylabels = [];
            _.each(chartData, x => {
                mydata.push(x['usedQuotaInMillion']);
                mylabels.push(x['productName']);
            });
            const barChartData = [{ data: mydata }, { data: [] } ]
            this.barChartData = barChartData;
            this.barChartData[0] = {
                backgroundColor: GRAPHITE_GREY,
                hoverBackgroundColor: GRAPHITE_GREY,
                borderColor: GRAPHITE_GREY,
                hoverBorderColor: GRAPHITE_GREY,
                ...this.barChartData[0]
            }
            this.barChartData[1] = {
                backgroundColor: AIA_BLUE,
                hoverBackgroundColor: AIA_BLUE,
                borderColor: AIA_BLUE,
                hoverBorderColor: AIA_BLUE,
                ...this.barChartData[1]
            }

            this.barChartLabels = mylabels;
            return;
        }
        const dataSets = [{
            label: 'current',
            backgroundColor: this.colorArray[0].backgroundColor,
            data: []
        }, {
            label: 'modelling',
            backgroundColor:  this.colorArray[1].backgroundColor,
            data: []
        }];
        const products = [];
        const dataByProduct = {};
        const simuDataByProduct = {};
        for (const item of chartSimuData) {
            if (products.indexOf(item.productName) === -1) {
                products.push(item.productName);
            }
            simuDataByProduct[item.productName] = item;
        }
        for (const item of chartData) {
            if (products.indexOf(item.productName) === -1) {
                products.push(item.productName);
            }
            dataByProduct[item.productName] = item;
        }
        for (const product of products.sort()) {
            if (isNil(dataByProduct[product])) {
                dataSets[0].data.push(0);
            } else {
                dataSets[0].data.push(dataByProduct[product].usedQuotaInMillion);
            }
            if (isNil(simuDataByProduct[product])) {
                dataSets[1].data.push(0);
            } else {
                dataSets[1].data.push(simuDataByProduct[product].usedQuotaInMillion);
            }
        }
        this.barChartData = dataSets;
        this.barChartLabels = products;
    }

    resetChartData() {
        this.barChartLabels = [];
        const barChartData = [ { data: [] }, { data: [] } ];
        this.barChartData = barChartData;
        this.barChartData[0].data = [];
    }

}
